import index from "./RegisterAccounting"
export default index